import React from 'react';
import { css } from '@emotion/react';
import { onMobile } from '@/styles/responsive';

interface AiBannerProps {
  onClick?: () => void;
}

function AiBanner({ onClick }: AiBannerProps) {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  // onClick이 있으면 button 요소로, 없으면 div 요소로 렌더링
  if (onClick) {
    return (
      <button
        css={[container, clickableStyle]}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        type="button"
        aria-label="AI로 단 하루 만에"
      >
        <img src="/assets/images/ai/ai-banner-title.png" alt="AI 배너 Title" css={titleStyle} />
        {/* <div css={textContainer}>
          <p css={aiText}>AI로</p>
          <p>단 <span css={highlightText}>하루</span> 만에</p>
        </div> */}
      </button>
    );
  }

  return <div css={container} />;
}

export default AiBanner;

const container = css`
  position: relative;
  width: 100%;
  border-radius: 12px;
  background-image: url('/assets/images/ai/ai-banner-frame.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 128px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;

  ${onMobile} {
    border-radius: 8px;
    height: 92px;
  }
`;

const clickableStyle = css`
  border: none;
  font: inherit;
  text-align: inherit;
  color: inherit;
  outline: none;
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

const titleStyle = css`
  width: 420px;
  height: 128px;

  ${onMobile} {
    width: 301.875px;
    height: 92px;
  }
`;

// const textContainer = css`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 15px;

//   color: var(--Semantic-text-white, #fff);
//   text-align: center;
//   font-feature-settings: 'liga' off, 'clig' off;
//   font-family: Pretendard;
//   font-size: 36.996px;
//   font-style: normal;
//   font-weight: 900;
//   line-height: 51.794px; /* 140% */

//   ${onMobile} {
//     color: var(--Semantic-text-white, #fff);
//     text-align: center;
//     font-feature-settings: 'liga' off, 'clig' off;
//     text-shadow: 0 0 21.435px rgba(255, 255, 255, 0.4);
//     font-family: Pretendard;
//     font-size: 23.579px;
//     font-style: normal;
//     font-weight: 900;
//     line-height: 55.511px; /* 235.427% */
//   }
// `;

// const highlightText = css`
//   color: var(--Semantic-text-white, #fff);
//   font-feature-settings: 'liga' off, 'clig' off;
//   font-family: Pretendard;
//   font-size: 53.812px;
//   font-style: normal;
//   font-weight: 900;
//   line-height: 75.337px;

//   ${onMobile} {
//     color: var(--Semantic-text-white, #fff);
//     font-feature-settings: 'liga' off, 'clig' off;
//     font-family: Pretendard;
//     font-size: 39.651px;
//     font-style: normal;
//     font-weight: 900;
//     line-height: 55.511px;
//   }
// `;

// const aiText = css`
//   color: var(--Semantic-text-white, #fff);
//   text-align: center;
//   font-feature-settings: 'liga' off, 'clig' off;
//   font-family: Pretendard;
//   font-size: 36.996px;
//   font-style: normal;
//   font-weight: 900;
//   line-height: 51.794px; /* 140% */

//   ${onMobile} {
//     color: var(--Semantic-text-white, #fff);
//     text-align: center;
//     font-feature-settings: 'liga' off, 'clig' off;
//     font-family: Pretendard;
//     font-size: 27.26px;
//     font-style: normal;
//     font-weight: 900;
//     line-height: 38.164px; /* 140% */
//   }
// `;
